<template>
    <div class="popup save_popup upgrade-popup sign-in">

        <a class="close_popup_btn" v-on:click="changePopup('resetPasswordPopup', false)">
            <span class="inch-icon inch-close-icon"></span>
        </a>
        <h2 class="title sm">Reset Password</h2>

        <div class="is_offline" v-if="isOffline">
            <Offline></Offline>
        </div>
        <form id="login_form" v-on:submit.prevent="onSubmit" v-if="isOnline">
            <div class="form_loading" v-if="isLoading"></div>

            <input type="hidden" ref="xtoken" name="token" :value="token">

            <div class="form-group">
                <div class="label">EMAIL</div>
                <input type="email" ref="xemail" name="email" class="form-control xemail" :value="email" />
            </div>
            <div class="form-group">
                <div class="label">NEW PASSWORD</div>
                <input type="password" ref="xpassword" name="password" class="form-control" :value="password" />
            </div>
            <div class="form-group">
                <div class="label">CONFIRM NEW PASSWORD</div>
                <input type="password" ref="xcpassword" name="cpassword" class="form-control" :value="cpassword" />
            </div>

            <div class="form_errors" v-if="formErrors">
                <ul id="example-1">
                    <li v-for="item in formErrors">{{ item[0] }}</li>
                </ul>
            </div>

            <div class="btn-wrap" style="display: flex;align-items: center;justify-content: space-between;">
                <input type="submit" class="btn-orange" value="Reset Password" style="padding: 15px 40px;" />

            </div>

        </form>
    </div>
</template>


<script>
import Acc from "@/libs/acc.js";
import Offline from "@/components/Offline.vue";

export default {
    name: "SignIn",
    data() {
        return {
            isLoading: false,
            acc: new Acc(),
            formErrors: null,
            isForgotPopup: false,
            token: "",
            email: "",
            password: "",
            cpassword: ""
        };
    },
    components: {
        Offline
    },
    mounted() {
        const urlParams = new URLSearchParams(window.location.search);
        this.email = urlParams.get("email");
        this.token = this.$route.params.token;
    },
    methods: {
        forgotPassword(status) {
            this.isForgotPopup = status;
        },
        async onSubmit(ev) {
            this.isLoading = true;
            this.formErrors = null;

            if (!this.$refs.xemail.value || !this.$refs.xpassword.value || !this.$refs.xcpassword.value) {
                this.isLoading = false;
                this.formErrors = [["All fields are required"]];
                return
            }
            if (this.$refs.xpassword.value.length < 8) {
                this.isLoading = false;
                this.formErrors = [["The password must be at least 8 characters"]];
                return
                
            }

            if (this.$refs.xpassword.value !== this.$refs.xcpassword.value) {
                this.isLoading = false;
                this.formErrors = [["Password does not match"]];
                return
            }

            const resp = await this.acc.resetNewPassword({
                email: this.$refs.xemail.value,
                password: this.$refs.xpassword.value,
                password_confirmation: this.$refs.xcpassword.value,
                token: this.$refs.xtoken.value
            });
            if (resp.status == true) {
                window.location.href = "/";
            }
            else {
                this.formErrors = [[resp.message]];
                this.isLoading = false;
            }

        },
        changePopup(property, value) {
            this.$store.dispatch("popupsToggle", { property, value });
        }
    }
};
</script>

<style>
.form_loading {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: #8080809c;
    z-index: 10000;
}

.btn-orange {
    border: none;
}

.form_errors {
    /*color: red;*/
    /*font-weight: bold;*/
    text-align: left;
    font: normal normal normal 14px/20px Soleil;
    color: #FF5353;
    letter-spacing: -0.28px;
}

.popup.save_popup.upgrade-popup.sign-in .title {
    font-size: 26px;
}

.form-group .label {
    font-size: 13px !important;
}


.popup.save_popup.upgrade-popup .btn-wrap .checkbox {
    text-transform: uppercase;
    font-size: 14px;
    padding-left: 30px;
}

.popup.save_popup.upgrade-popup .btn-wrap .check {
    border-color: #E5E5E5;
}

.popup.save_popup.upgrade-popup .btn-wrap input:checked~.check {
    background-color: #FA6400;
    border-color: #FA6400;
}

.popup.save_popup.upgrade-popup .btn-wrap input:checked~.check::after {
    border-color: #fff;
}

.popup.save_popup.upgrade-popup .btn-wrap a.change-sub-card {
    margin-bottom: 12px;
    display: inline-block;
    text-transform: uppercase;
    text-align: center;
    font: normal normal normal 14px/18px Soleil;
    letter-spacing: -0.28px;
    color: #FFFFFF;
}

.popup.save_popup.upgrade-popup .btn-wrap a.update-card {
    margin-bottom: 12px;
    display: inline-block;
    text-transform: uppercase;
    text-align: center;
    font: normal normal normal 14px/18px Soleil;
    letter-spacing: -0.28px;
    color: #FFFFFF;
}

.popup.save_popup.upgrade-popup .btn-wrap a {
    margin-bottom: 12px;
    display: inline-block;
    text-transform: uppercase;
    /*color: #1d1d1d;*/
    font: normal normal normal 14px/18px Soleil;
    letter-spacing: -0.28px;
    color: #FFFFFF;
}
</style>
